import React from 'react';
import { useIntl } from 'react-intl';
import { Error } from '@crm-in-store/crmis-signup-ui-kit';
import {
  InitialDataProps,
  withInitialData,
} from '../../v3/hocs/withInitialData';
import useAppErrors from './useAppErrors';
import useConfigurationErrorHandler from './useConfigurationErrorHandler';
import useNetworkErrorHandler from './useNetworkErrorHandler';
import getOriginByQueryParams from '../../helpers/getOriginByQueryParams';
import useAppErrorTracker from './useAppErrorTracker';

const AppError = ({
  country,
  storeId,
  source,
}: InitialDataProps): JSX.Element | null => {
  const intl = useIntl();
  const errors = useAppErrors();

  const origin = getOriginByQueryParams(storeId, source);

  useConfigurationErrorHandler(country, origin);
  useNetworkErrorHandler();
  useAppErrorTracker();

  if (errors.length === 0) return null;

  const codeValue = errors[errors.length - 1].code;
  const code = codeValue
    ? {
        value: codeValue,
        label: intl.formatMessage({
          id: 'error_code_text',
          defaultMessage: 'Missing translation',
        }),
      }
    : undefined;

  return (
    <Error
      text={intl.formatMessage({
        id: errors[errors.length - 1].translationKey,
        defaultMessage: 'Missing translation',
      })}
      code={code}
    />
  );
};

export default withInitialData(AppError);
